import { render, staticRenderFns } from "./GewerbeSummaryBox.vue?vue&type=template&id=78adbbea&scoped=true&"
import script from "./GewerbeSummaryBox.vue?vue&type=script&lang=js&"
export * from "./GewerbeSummaryBox.vue?vue&type=script&lang=js&"
import style0 from "./GewerbeSummaryBox.vue?vue&type=style&index=0&id=78adbbea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78adbbea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VDivider,VRow})
